import React from 'react';
import {CodesForm} from '../../components/Form/CodesForm';
import {useEditGuestForm} from '../../hooks/guests';
import {CodeGroupT} from '../../external_usage';

export const EditGuestForm = ({group}: {group?: CodeGroupT}) => {
  const {values, error, handleChange} = useEditGuestForm();
  return <CodesForm values={values} error={error} handleChange={handleChange} group={group} />;
};
